var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.165 110.507c4.055 0 8.107 1.493 11.308 4.692 6.188 6.188 6.188 16.428 0 22.615L97.285 255.999l118.188 118.187c6.188 6.187 6.188 16.427 0 22.613s-16.428 6.187-22.613 0L63.365 267.306c-6.185-6.187-6.185-16.428 0-22.612L192.86 115.199c3.2-3.2 7.252-4.692 11.305-4.692"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.297 240h359.04c8.747 0 16 7.252 16 16s-7.253 16-16 16H78.297c-8.748 0-16-7.253-16-16s7.252-16 16-16"
  })));
};
export default SvgArrowLeft;